"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactJss = require("react-jss");

var _default = (0, _reactJss.withStyles)(function (_ref) {
  var _root, _headSpan, _section, _bottomstrip;

  var screens = _ref.screens,
      colors = _ref.colors,
      logo = _ref.logo,
      spacing = _ref.spacing;
  return {
    root: (_root = {
      background: '#fafafa',
      color: colors.secondaryDarkContrast,
      position: 'relative'
    }, _defineProperty(_root, screens.mdUp, {
      '& li': {
        marginBottom: spacing.xs
      }
    }), _defineProperty(_root, screens.smDown, {
      padding: "".concat(spacing.xl, "px 0 ").concat(spacing.xl, "px")
    }), _defineProperty(_root, screens.xsDown, {
      padding: "".concat(spacing.xl, "px 0 ").concat(spacing.xxl, "px")
    }), _root),
    sections: _defineProperty({}, screens.mdUp, {
      width: '88.88%',
      maxWidth: 960,
      marginRight: 'auto',
      marginLeft: 'auto',
      display: 'flex',
      flexWrap: 'wrap'
    }),
    head: _defineProperty({
      width: '100%',
      textAlign: 'center'
    }, screens.mdUp, {
      padding: "".concat(spacing.xxl, "px 0 ").concat(spacing.lg, "px"),
      borderBottom: '1px solid #EDEDED',
      marginBottom: spacing.lg,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }),
    headSpan: (_headSpan = {}, _defineProperty(_headSpan, screens.mdUp, {
      textTransform: 'uppercase',
      marginTop: spacing.md
    }), _defineProperty(_headSpan, screens.smDown, {
      display: 'none'
    }), _headSpan),
    network: {
      width: 86,
      display: 'inline-block'
    },
    networkInner: {
      display: 'inline-block',
      height: 0,
      paddingBottom: '54%',
      background: "url(/assets/images/aenetworks/aetn-charcoal-stacked.svg) no-repeat center center",
      backgroundSize: 'contain',
      textIndent: '-9999px'
    },
    section: (_section = {}, _defineProperty(_section, screens.mdUp, {
      padding: "0 ".concat(spacing.xxxl, "px"),
      boxSizing: 'content-box'
    }), _defineProperty(_section, screens.smDown, {
      display: 'none'
    }), _section),
    sectionInner: _defineProperty({}, screens.mdUp, {
      '&:not(:last-child)': {
        borderBottom: '1px solid #ededed',
        paddingBottom: spacing.lg,
        marginBottom: spacing.xl
      }
    }),
    sectionGrow: _defineProperty({}, screens.mdUp, {
      flexGrow: 1
    }),
    sectionFixed: _defineProperty({}, screens.mdUp, {
      width: 600,
      paddingLeft: spacing.lg
    }),
    logo: _defineProperty({}, screens.mdUp, {
      display: 'block',
      height: 60,
      maxWidth: 85,
      marginBottom: 20,
      background: "url(".concat(logo.black, ") no-repeat left center"),
      backgroundSize: 'contain',
      opacity: 0.6,
      transition: 'all 0.3s ease-out'
    }),
    socialIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid rgba(0,0,0,0.16)',
      width: 30,
      height: 30,
      fontSize: 18,
      borderRadius: 30
    },
    textLinks: _defineProperty({}, screens.mdUp, {
      '& a': {
        borderBottom: '1px solid transparent',
        transition: 'all 0.15s linear',
        '&:hover': {
          borderColor: 'rgba(0,0,0,0.8)',
          color: 'rgba(0,0,0,0.8)'
        }
      }
    }),
    iconLinks: _defineProperty({}, screens.mdUp, {
      '& a:hover': {
        opacity: 1,
        transform: 'scale(1.06) translate3d(0, 0, 0)'
      }
    }),
    channels: _defineProperty({}, screens.mdUp, {
      display: 'flex',
      '& li': {
        marginRight: spacing.xxl,
        marginBottom: spacing.lg,
        '& a': {
          transition: 'all 0.3s ease-out',
          display: 'block',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          height: 60,
          opacity: 0.6
        }
      }
    }),
    links: _defineProperty({}, screens.mdUp, {
      display: 'flex',
      '& ul:not(:last-child)': {
        marginRight: spacing.xl,
        width: 180
      }
    }),
    aetv: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/aetv/logo.svg)",
      width: 60
    }),
    history: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/history/logo-black.svg)",
      width: 54
    }),
    lifetime: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/lifetime/logo-black.svg)",
      width: 94
    }),
    lmn: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/lmn/logo-black.svg)",
      width: 66
    }),
    fyi: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/fyi/logo-black.svg)",
      width: 62
    }),
    viceland: _defineProperty({}, screens.mdUp, {
      backgroundImage: "url(/assets/images/viceland/logo.svg)",
      width: 82
    }),
    followHead: _defineProperty({
      color: colors.secondaryDarkContrast,
      display: 'block'
    }, screens.mdUp, {
      margin: "".concat(spacing.lg, "px 0 ").concat(spacing.md, "px")
    }),
    social: _defineProperty({}, screens.mdUp, {
      maxWidth: 150,
      '& li': {
        display: 'inline-block',
        marginRight: spacing.xs,
        marginBottom: spacing.sm
      },
      '& .icon': {
        display: 'inline-block',
        border: '1px solid rgba(0,0,0,0.16)',
        width: 30,
        height: 30,
        borderRadius: 30,
        lineHeight: '34px',
        fontSize: '18px',
        textAlign: 'center',
        transition: 'all 0.3s ease-out'
      }
    }),
    bottomstrip: (_bottomstrip = {
      '& p': _defineProperty({
        color: colors.secondaryDarkContrast,
        display: 'inline-block',
        fontSize: 12
      }, screens.mdUp, {
        fontSize: 14
      })
    }, _defineProperty(_bottomstrip, screens.mdUp, {
      background: '#fff',
      borderTop: '1px solid rgba(0,0,0,0.05)',
      padding: "".concat(spacing.md, "px 0"),
      marginTop: spacing.xl,
      fontSize: '12px',
      lineHeight: '2em',
      textAlign: 'center',
      '& ul': {
        display: 'none'
      }
    }), _defineProperty(_bottomstrip, screens.smDown, {
      textAlign: 'center',
      '& ul': {
        fontSize: '12px',
        margin: "".concat(spacing.xl, "px 0 ").concat(spacing.lg, "px")
      },
      '& li': {
        display: 'inline-block',
        '&:after': {
          content: "\"\"",
          display: 'inline-block',
          width: 1,
          height: 12,
          backgroundColor: 'rgba(0,0,0,0.15)',
          margin: '0 0 0 4px',
          position: 'relative',
          top: 1
        },
        '&:last-child': {
          '&:after': {
            display: 'none'
          }
        },
        '& a': {
          color: colors.secondaryDarkContrast,
          padding: 6,
          display: 'inline-block'
        }
      }
    }), _bottomstrip)
  };
});

exports["default"] = _default;